"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUpdateSettingsParams = exports.buildUpdateSettingsUrl = exports.transformActiveService = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var serviceIsEmpty = (0, _ramda.propEq)('service', null);
var transformActiveService = (0, _ramda.ifElse)(serviceIsEmpty, (0, _ramda.prop)('service'), (0, _ramda.pipe)((0, _ramda.omit)(['success']), function (_ref) {
  var service = _ref.service,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["service"]);
  return _objectSpread(_objectSpread({}, service), rest);
}, (0, _utils.renameKeys)({
  using_dkim: 'usingDkim',
  use_email_integration: 'useEmailIntegration',
  use_calendar_integration: 'useCalendarIntegration'
})));
exports.transformActiveService = transformActiveService;

var buildUpdateSettingsUrl = function buildUpdateSettingsUrl(type) {
  return "/enterprise/dashboard/settings/update/integration-".concat(type, "-setting");
};

exports.buildUpdateSettingsUrl = buildUpdateSettingsUrl;

var buildUpdateSettingsParams = function buildUpdateSettingsParams(_ref2) {
  var type = _ref2.type,
      value = _ref2.value;
  return {
    ["use_".concat(type, "_integration")]: value
  };
};

exports.buildUpdateSettingsParams = buildUpdateSettingsParams;